export function Skeleton({ className = "" }: { className?: string }) {
  return <div className={`skel rounded-md ${className}`} />;
}

/** A row of skeleton cells matching a real <tr>, for table loading states. */
export function SkeletonRow({ columns }: { columns: number }) {
  return (
    <tr className="border-t border-slate-100 dark:border-white/5">
      {Array.from({ length: columns }).map((_, i) => (
        <td key={i} className="p-3">
          <Skeleton className="h-3.5 w-full max-w-[8rem]" />
        </td>
      ))}
    </tr>
  );
}

export function SkeletonRows({ columns, rows = 6 }: { columns: number; rows?: number }) {
  return (
    <>
      {Array.from({ length: rows }).map((_, i) => (
        <SkeletonRow key={i} columns={columns} />
      ))}
    </>
  );
}
